(function() {
    'use strict';

    angular.module('settings').controller('TagListController', TagListController);

    TagListController.$inject = [
        '$state',
        'tagsDataSrvc',
        'tagsSrvc',
        'notificationSrvc',
        'tagsPermissionsConst',
        'tagsMessagesConst',
        'lodashService',
        'datatableDefaultPageSizeValueConst',
        'searchFilterSrvc',
        'checkSearchSrvc',
        'filterQuerySrvc'
    ];

    function TagListController(
        $state, tagsDataSrvc, tagsSrvc, notificationSrvc, tagsPermissionsConst, tagsMessagesConst, lodashService,
        datatableDefaultPageSizeValueConst, searchFilterSrvc, checkSearchSrvc, filterQuerySrvc
    ) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.tagRows = [];
        self.tagCols = [{
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = tagsPermissionsConst;
        self.searchQuery = {
            name: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getTags();
        }

        function getTags(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    ordering: self.searchQuery.ordering
                };
            }
            return tagsDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.tagRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getTags);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.tags.create');
        }

        function onEdit(row) {
            $state.go('layout.tags.update', { pk: row.pk });
        }

        function onDelete(row) {
            return tagsSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", tagsMessagesConst.delete);
                lodashService.remove(self.tagRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getTags();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getTags();
        }
    }
})();
